import React from 'react'
import PropTypes from 'prop-types'
import {Box, UnorderedList, ListItem, Image} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import Carousel from '../../../../../components/Carousel'

import FirstSlideContent from '../../../../../../../assets/images/accounting_provider_connect_slides/pop_slide_1.gif'
import SecondSlideContent from '../../../../../../../assets/images/accounting_provider_connect_slides/pop_slide_2.gif'
import XeroSlideContent from '../../../../../../../assets/images/accounting_provider_connect_slides/pop_slide_3_xero.gif'
import MYOBSlideContent from '../../../../../../../assets/images/accounting_provider_connect_slides/pop_slide_3_myob.gif'
import QuickbooksSlideContent from '../../../../../../../assets/images/accounting_provider_connect_slides/pop_slide_3_quickbooks.gif'

const NumberIcon = ({children}) => {
  return (
    <Box
      width="24px"
      height="24px"
      minW="24px"
      minH="24px"
      mr="md"
      borderRadius="full"
      backgroundColor="mld.neutral.1000"
      color="mld.neutral.0"
      textAlign="center"
    >
      {children}
    </Box>
  )
}

NumberIcon.propTypes = {
  children: PropTypes.node.isRequired,
}

const LastSlideContent = (accountingProvider) => {
  if (accountingProvider === 'Xero') {
    return XeroSlideContent
  }
  if (accountingProvider === 'MYOB') {
    return MYOBSlideContent
  }
  if (accountingProvider === 'Quickbooks') {
    return QuickbooksSlideContent
  }

  return XeroSlideContent
}

const useLearnMoreSlides = (accountingProvider) => {
  const {t} = useTranslation('onboarding')

  return [
    {
      key: '1',
      slideContent: <Image src={FirstSlideContent} />,
      footerContent: (
        <Box
          textStyle="body-copy"
          display="flex"
          borderColor="mld.neutral.500"
          borderTopWidth="1px"
          borderBottomWidth="1px"
          py="sm"
        >
          <NumberIcon>1</NumberIcon>
          {t('onboarding:AccountIntegrationConnect.listItems.1', {
            context: 'PointsOnPayments',
          })}
        </Box>
      ),
    },
    {
      key: '2',
      slideContent: <Image src={SecondSlideContent} />,
      footerContent: (
        <Box
          textStyle="body-copy"
          display="flex"
          borderColor="mld.neutral.500"
          borderTopWidth="1px"
          borderBottomWidth="1px"
          py="sm"
        >
          <NumberIcon>2</NumberIcon>
          {t('onboarding:AccountIntegrationConnect.listItems.2', {
            context: 'PointsOnPayments',
          })}
        </Box>
      ),
    },
    {
      key: '3',
      slideContent: <Image src={LastSlideContent(accountingProvider)} />,
      footerContent: (
        <Box
          textStyle="body-copy"
          display="flex"
          borderColor="mld.neutral.500"
          borderTopWidth="1px"
          borderBottomWidth="1px"
          py="sm"
        >
          <NumberIcon>3</NumberIcon>
          {t('onboarding:AccountIntegrationConnect.listItems.3', {
            context: 'PointsOnPayments',
          })}
        </Box>
      ),
    },
  ]
}

const ConnectionReasons = ({accountingProvider, signupProduct}) => {
  const {t} = useTranslation('onboarding')
  const learnMoreSlides = useLearnMoreSlides(accountingProvider)

  return signupProduct === 'points_on_payments' ? (
    <Box mb="md">
      <Carousel slides={learnMoreSlides} autoPlay />
    </Box>
  ) : (
    <UnorderedList mb="md" ml="0" styleType="none">
      <ListItem
        textStyle="body-copy"
        display="flex"
        borderColor="mld.neutral.500"
        borderTopWidth="1px"
        borderBottomWidth="1px"
        py="sm"
      >
        <NumberIcon>1</NumberIcon>
        {t('onboarding:AccountIntegrationConnect.listItems.1')}
      </ListItem>
      <ListItem textStyle="body-copy" display="flex" py="sm">
        <NumberIcon>2</NumberIcon>
        {t('onboarding:AccountIntegrationConnect.listItems.2')}
      </ListItem>
      <ListItem
        textStyle="body-copy"
        display="flex"
        borderColor="mld.neutral.500"
        borderTopWidth="1px"
        borderBottomWidth="1px"
        py="sm"
      >
        <NumberIcon>3</NumberIcon>
        {t('onboarding:AccountIntegrationConnect.listItems.3')}
      </ListItem>
    </UnorderedList>
  )
}

ConnectionReasons.propTypes = {
  accountingProvider: PropTypes.string.isRequired,
  signupProduct: PropTypes.oneOf(['points_on_payments', 'payments_on_demand'])
    .isRequired,
}

export default ConnectionReasons
